import React, { Component } from 'react';
import twitter from '../../../assets/twitter-icon.png';

import PropTypes from 'prop-types';

class Twitter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            status: '',
            postTweets: localStorage.getItem('postTweets') === 'true'
        };
        
        this.token = this.props.token;
    }

    componentDidMount() {
      const { username } = this.props.user.user;
      this.getTwitterStatus(username, this.token);
    }

    changeCanPostTweets = (e) => {
      this.setState({ postTweets: !!e.target.checked });
      localStorage.setItem('postTweets', `${!!e.target.checked}`);
    };

    getTwitterStatus(user, token) {
        this.props.api.twitter.getUser({
            user,
            token,
        })
            .then(response => {
                this.setState({ status: response.status });
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });
    }

    connectTwitter = () => {
        const { username } = this.props.user.user;
        this.props.api.twitter.postUser({
            user: username,
            token: this.token
        })
            .then(async (response) => {
                let json = await response.json();
                window.location.assign(json.authUrl);
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });

        return false;
    };

    disconnectTwitter = () => {
        const { username } = this.props.user.user;
    
        this.props.api.twitter.deleteUser({
            user: username,
            token: this.token
        })
            .then(() => {
                this.getTwitterStatus(username, this.token);
                this.setState({ postTweets: false });
                localStorage.setItem("postTweets", "false");
            })
            .catch(err => {
                console.error(err);
                this.setState({ status: 'error' });
            });
    };
    
    onErrorClick = () => {
        const { username } = this.props.user.user;
        
        this.getTwitterStatus(username, this.token)
    };

    renderPod = () => {
        const { status, postTweets } = this.state;
        
        if (status === 'error') {
            return (
                <div>
                    <p>An error was encountered</p>
                    <button
                        className="btn btn-black"
                        onClick={this.onErrorClick}
                    >
                        Retry
                    </button>
                </div>
            );
        } else if (status > 299) {
            return (
                <div className="form">
                    <p className="p-info">
                        Notify your followers when you start a stream. Please enter your Twitter
                        credentials below to get started.{' '}
                    </p>
            
                    <div className="sec">
                        <button
                            className="btn btn-black"
                            onClick={this.connectTwitter}
                        >
                            Authorize
                        </button>
                    </div>
                </div>
            );
        } else if (status > 199 && status < 300) {
            return (
                <div>
                    <p>You are connected to Twitter.</p>
            
                    {/*<div style={{ marginBottom: '10px' }}>*/}
                    {/*    <input type="checkbox" onChange={this.changeCanPostTweets} checked={postTweets} disabled={true}/>*/}
                    {/*    <span style={{ marginLeft: '5px'}}>Automatically post tweet on stream start?</span>*/}
                    {/*</div>*/}
            
                    <button
                        className="btn btn-black"
                        onClick={this.disconnectTwitter}
                    >
                        Disconnect
                    </button>
                </div>
            );
        }
    };

    render() {
        return (
            <div>
                <div className="pod social">
                    <div className="icon">
                        <img src={twitter} alt="" />
                    </div>
                    <div className="pod-content">
                        <div className="title">Twitter</div>
                        {this.renderPod()}
                    </div>
                </div>
            </div>
        );
    }
}

Twitter.propTypes = {
    api: PropTypes.object.isRequired,
    token: PropTypes.string.isRequired,
    user: PropTypes.object.isRequired
};

export default Twitter;
